import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { Button } from '../../components/Button/Button';

interface IScrollToBtn {
    title: string;
    className?: string;
    anchorSelector: string;
    disabled?: boolean;
    isMobile?: boolean;
}

const ScrollToBtn = (props: IScrollToBtn) => {
    const { title } = props;
    const disabled = props.disabled || false;

    const handleScroll = () => {
        let anchor = document.querySelector(props.anchorSelector);
        if (anchor) {
            anchor.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    return (
        <Button
            onClick={handleScroll}
            disabled={disabled}
            fullWidth={props.isMobile}
            size={props.isMobile ? 'large' : 'medium'}
            className={props.className}
            endIcon={<ArrowDownIcon width={12} height={12} />}
        >
            {title}
        </Button>
    );
};

export default ScrollToBtn;
